import {
  setReportCounts,
  setToggleState,
	setRefReportAggs,
  clear,
} from './actions';

import { 
	thunkSetRefReportAggs, 
	thunkToggle, 
	thunkSetToggleStateAll,
} from './thunks';

export {
	// PURE ACTION CREATORS
  setReportCounts,
  setToggleState,
	setRefReportAggs,
  clear,

	// THUNKS
	thunkSetRefReportAggs, 
	thunkToggle, 
	thunkSetToggleStateAll,
};

export default {
	// PURE ACTION CREATORS
  setReportCounts,
  setToggleState,
	setRefReportAggs,
  clear,

	// THUNKS
	thunkSetRefReportAggs, 
	thunkToggle, 
	thunkSetToggleStateAll,
};
